import React, { useContext, useState } from "react";
import { languages } from "../../languages/languages";
import UserContext from "../../languages/UserContext";
import emailjs from "@emailjs/browser";

import { Facebook, Instagram, Phone, Point, Mail } from "../svg/Svgs";

import "./ContactBlock.scss";

const ContactBlock = () => {
  const user = useContext(UserContext);

  const [formSent, setFormSent] = useState(false);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await emailjs.send(
        "service_5wrva1j", // Replace this
        "template_4hxu1b1", // Replace this
        {
          from_name: name,
          reply_to: email,
          message: message,
        },
        "j_84QcYLVPulzorhq" // Replace this
      );

      setName("");
      setEmail("");
      setMessage("");
      setFormSent(true);
    } catch (error) {
      console.error("Error:", error);
      alert(languages[user.lang].FormError || "Failed to send message");
    }
  };

  return (
    <section className="contact" id="contact">
      <div className="contact-info-wrap">
        <div className="contact-info">
          <p className="contact-info-header">
            {languages[user.lang].ContactInfoHeader}
          </p>
          <p className="contact-info-detail">
            {languages[user.lang].ContactInfoText}
          </p>
        </div>
        <div className="contact-access">
          <div className="contact-wrap">
            <div className="thumbnail">
              <Phone></Phone>
            </div>
            <div>
              <span>+48 574 477 778</span>
              <span>+48 733 677 084</span>
            </div>
          </div>
          <div className="contact-wrap">
            <div className="thumbnail">
              <Mail></Mail>
            </div>
            <a href="mailto:dreamh.y.a.k.@gmail.com">dreamh.y.a.k.@gmail.com</a>
          </div>
          <div className="contact-wrap">
            <div className="thumbnail">
              <Point></Point>
            </div>
            <span>ul. Kunickiego 5/201, 30-134 Krakow </span>
          </div>
          <div className="contact-wrap-social">
            <a
              href="https://www.facebook.com/alex.dreamhouse.3"
              target="_blank"
              rel="noreferrer"
              className="thumbnail-social"
            >
              <Facebook colorOne="#121A27"></Facebook>
            </a>
            <a
              href="https://www.instagram.com/dhouseyacom/"
              className="thumbnail-social"
              target="_blank"
              rel="noreferrer"
            >
              <Instagram colorOne="#121A27"></Instagram>
            </a>
          </div>
        </div>
      </div>
      <div className="contact-form-wrap">
        <form
          onSubmit={(e) => {
            handleSubmit(e);
          }}
          className="contact-form"
        >
          <div className="input-wrap">
            <label className="form-label">
              {languages[user.lang].FormName}
            </label>
            <input
              className="form-input"
              value={name}
              id="name"
              name="name"
              type="text"
              onChange={(event) => setName(event.target.value)}
              required
            />
          </div>
          <div className="input-wrap">
            <label className="form-label">
              {languages[user.lang].FormEmail}
            </label>
            <input
              className="form-input"
              id="email"
              name="email"
              type="text"
              value={email}
              required
              onChange={(event) => setEmail(event.target.value)}
            />
          </div>
          <div className="input-wrap">
            <label className="form-label">
              {languages[user.lang].FormMessage}
            </label>
            <textarea
              className="form-textarea"
              id="message"
              name="message"
              rows="8"
              type="text"
              value={message}
              onChange={(event) => setMessage(event.target.value)}
            />
          </div>
          <button className="form-button">
            {languages[user.lang].FormButton}
          </button>
          <p
            className={`form-feedback ${
              formSent ? "form-feedback--shown" : ""
            } `}
          >
            {languages[user.lang].FormFeedback}
          </p>
        </form>
      </div>
    </section>
  );
};

export default ContactBlock;
